import { memo, ReactNode, useCallback, useMemo } from 'react';
import { MediaOnChange, MediaState } from '../domain/media-file.types';
import { mediaReducer } from '../reducer/media.reducer';
import { MediaContext } from '../media.context';
import { useMediaPreviewer, useVideoMetadata } from '../hooks';
import { MediaEvent } from '../media.events';

type MediaRootProps = {
  children: ReactNode;
  files: MediaState;
  onChange: MediaOnChange;
};

export const MediaRoot = memo((props: MediaRootProps) => {
  const { children, files, onChange } = props;
  const previewer = useMediaPreviewer({ total: files.length });

  const dispatch = useCallback(
    (event: MediaEvent) => {
      const next = mediaReducer(files, event);
      onChange?.(event, next);

      return next;
    },
    [onChange, files]
  );

  useVideoMetadata(files, dispatch);

  const contextValue = useMemo(
    () => ({
      files,
      previewer,
      dispatch,
    }),
    [files, previewer, dispatch]
  );

  return (
    <MediaContext.Provider value={contextValue}>
      {children}
    </MediaContext.Provider>
  );
});
